/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { ADDRESS_FROM_ZIPCODE_REQUEST, success, failure } from './action';

const fetchAgreements = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(ADDRESS_FROM_ZIPCODE_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((params) =>
      AjaxRequest.open(
        'post',
        '/openservices/addressfromzipcode',
        params,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(fetchAgreements);
